// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
import React from 'react';
import clsx from 'clsx';
import InternalIcon from '../../../icon/internal';
export function CustomizableIcon({ customIcon, fallback, ...shared }) {
    if (customIcon) {
        return React.createElement(InternalIcon, { ...shared, override: customIcon });
    }
    return React.createElement(InternalIcon, { ...shared, ...fallback, className: clsx(shared.className, fallback === null || fallback === void 0 ? void 0 : fallback.className) });
}
//# sourceMappingURL=index.js.map